const appConfig = {
  bookFormat: 'PDF',
  applicationId: 'evg',
  isStudent: false,
  showAudio: false,
  showBackNav: true,
  showBookmark: false,
  showDrawer: true,
  showHeader: true,
  showHighlights: false,
  showNavigation: true,
  showPageLayout: false,
  showPref: true,
  showPrintPageNav: true,
  showSearch: false,
  showStudy: false,
  showTOC: true
};

/** R+ EPUB preview: EPUB reader; print page nav off (no annotation service in Evergreen). */
const defaultRplusEpubPreviewConfig = {
  ...appConfig,
  bookFormat: 'EPUB',
  showPrintPageNav: false
};

const defaultRplusConfig = {
  bookFormat: 'PDF',
  applicationId: 'evg',
  isStudent: false,
  showAudio: false,
  showBackNav: true,
  showBookmark: false,
  showDrawer: true,
  showHeader: true,
  showHighlights: false,
  showNavigation: true,
  showPageLayout: false,
  showPref: true,
  showPrintPageNav: true,
  showSearch: false,
  showStudy: false,
  showTOC: true,
  showResource: true
};

class VegaConfig {
  getVegaConfig = () => {
    return appConfig;
  };

  getRpluseConfig = () => {
    return defaultRplusConfig;
  };

  getRplusEpubPreviewConfig = () => {
    return defaultRplusEpubPreviewConfig;
  };
}

export default VegaConfig;
